// LoadingSpinner.jsx
import React from 'react';
import './loadingspinner.css'; // Make sure to create and link this CSS file

const LoadingSpinner = () => {
    return <div className="connecting-spinner"></div>;
};

export default LoadingSpinner;
